import { BridgeComponent } from "@hotwired/hotwire-native-bridge";

export default class extends BridgeComponent {
  static component = "switch-subdomain";

  static targets = ["adminSubdomain"];

  switchSubdomain(e) {
    e.preventDefault();

    this.send("switchSubdomain", { subdomain: this.element.dataset.bridgeSubdomain }, () => {
      // no-op, navigation would have occured by now.
    })
  }

  adminSwitch(e) {
    e.preventDefault();
    this.send("switchSubdomain", { subdomain: this.adminSubdomainTarget.value }, () => {
      // no-op, navigation would have occured by now.
    })
  }

}